export default __webpack_public_path__ + "static/media/grades-summary.37d928c1.svg";